module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.iterators.js
// module id = 42
// module chunks = 0